import React, { useState, useEffect } from 'react';
import {
  Typography,
  Space,
  Button,
  Table,
  Input,
  Image,
  Modal,
  theme,
  Popconfirm,
  Form,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import CorporateTraderService from '../../services/CorporateTraderService';
import { ShowDetail } from '../ShareHoldingPage';
import { useAuth } from '../../hooks/useAuth';
import WorkflowAccModificationService from '../../services/WorkflowAccModificationService';
import { convertToLocal } from '../../components/Functions/convertToLocal';

const { Title } = Typography;

export default function CorporateTraderList({ isModification }) {
  const location = useLocation();
  const [applicationList, setApplicationList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [totalCount, setTotalcount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [clickedId, setClickedId] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openModify, setOpenModify] = useState(false);
  // const [accountNo, setAccountNo] = useState('');
  const { showNotification } = useAuth();

  // Read application list
  const loadData = async () => {
    const searchParams = new URLSearchParams(location.search);
    const pageParam = searchParams.get('page') || 1;
    const sizeParam = searchParams.get('size') || 10;
    setPage(Number(pageParam) || 1);
    setSize(Number(sizeParam) || 10);
    setLoading(true);
    const response = await CorporateTraderService.getCorporateTraderList({
      // traderStageList: ['APPROVED'],
      // tradingAccountNo: accountNo || null,
      firmName: searchText || null,
      page: pageParam,
      size: sizeParam,
    });

    // const approvedApplications = response.traderList.filter(item => item.stage === 'APPROVED');
    if (response.success === true) {
      setApplicationList(
        response.traderList.map(data => ({
          ...data,
          key: data.tradingAccountNo,
        })),
      );
      setTotalcount(response.totalCount);
    } else {
      showNotification('error', response.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!isModification) {
      loadData();
    }
  }, [location.search, searchText]);

  const hanldeModifyTrader = async tradingAccountNo => {
    setConfirmLoading(true);
    const response = await WorkflowAccModificationService.prepareCorporateAcc({
      tradingAccountNo: tradingAccountNo,
    });
    setOpenModify(false);
    setClickedId(null);
    setConfirmLoading(false);
    if (response.success) {
      showNotification('success', 'Done! Successfully modified user status.');
      navigate('/modification/corporate/' + response.data.workFlowId);
    } else {
      showNotification('error', response.message);
    }
    console.log(response);
  };

  const handleCancel = () => {
    setOpenModify(false);
    setClickedId(null);
  };

  const showPopconfirm = (id, type) => {
    setClickedId(id);
    setOpenModify(true);
  };

  // Table columns
  const tableColumns = [
    {
      title: 'Trading Account No.',
      dataIndex: 'tradingAccountNo',
      key: 'tradingAccountNo',
      render: (_, record) => {
        return (
          <Button type="link" onClick={() => showDetail(record.tradingAccountNo)}>
            {record.tradingAccountNo}
          </Button>
        );
      },
    },
    {
      title: 'Application No.',
      dataIndex: 'applicationNo',
      key: 'applicationNo',
    },
    {
      title: 'Approved At',
      dataIndex: 'approvedDate',
      key: 'approvedDate',
      render: (_, record) => <>{record.approvedDate ? convertToLocal(record.approvedDate) : '—'}</>,
    },
    {
      title: 'Firm Name',
      dataIndex: 'firmName',
      key: 'firmName',
    },
    {
      title: 'Client Type',
      dataIndex: 'clientType',
      key: 'clientType',
    },
    {
      title: 'Primary Email',
      dataIndex: 'primaryEmail',
      key: 'primaryEmail',
    },
    {
      title: 'Registration No.',
      dataIndex: 'registrationNo',
      key: 'registrationNo',
    },
    // {
    //   title: 'Stage',
    //   dataIndex: 'stage',
    //   key: 'stage',
    //   render: (text, record) => {
    //     switch (record.stage) {
    //       case 'MIGRATING':
    //         return (
    //           <Tag color="#E7E6C6" style={{ borderRadius: '20px' }}>
    //             {text}
    //           </Tag>
    //         );
    //       case 'PREPARING':
    //         return (
    //           <Tag color="#503FB3" style={{ borderRadius: '20px' }}>
    //             {text}
    //           </Tag>
    //         );
    //       case 'SUBMITTED':
    //         return (
    //           <Tag color="#B33FA2" style={{ borderRadius: '20px' }}>
    //             {text}
    //           </Tag>
    //         );
    //       case 'APPROVED':
    //         return (
    //           <Tag color="#3FB350" style={{ borderRadius: '20px' }}>
    //             {text}
    //           </Tag>
    //         );
    //       case 'REJECTED':
    //         return (
    //           <Tag color="#D85C5C" style={{ borderRadius: '20px' }}>
    //             {text}
    //           </Tag>
    //         );
    //       default:
    //         break;
    //     }
    //   },
    // },
    {
      title: 'Detail',
      key: 'detail',
      render: (_, record) => (
        <>
          {/* <Button
            icon={<Image src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} preview={false} />}
            type={'link'}
            onClick={() => navigate(`/corporate/detail/${record.traderId}`)}
          ></Button> */}
          <Button
            type={'primary'}
            size="small"
            onClick={() => navigate(`/corporate/detail/${record.traderId}`)}
          >
            View
          </Button>
          {/* <Button onClick={() => handleApprove(record.traderId)}>Approve</Button> */}
        </>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          <Popconfirm
            title={record.tradingAccountNo}
            description="Are you sure to modify this trader?"
            open={clickedId === record.applicationNo && openModify}
            onConfirm={() => hanldeModifyTrader(record.tradingAccountNo)}
            okButtonProps={{ loading: confirmLoading }}
            onCancel={handleCancel}
          >
            <Button size={'small'} danger onClick={() => showPopconfirm(record.applicationNo)}>
              Modify
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  // primary theme
  const {
    token: { colorPrimary },
  } = theme.useToken();

  const [open, setOpen] = useState(false);
  const [tradingAccountNo, setTradingAccountNo] = useState();

  const showDetail = tradingAccountNo => {
    setOpen(true);
    setTradingAccountNo(tradingAccountNo);
  };

  const handleSearch = async formValues => {
    // setAccountNo(formValues.tradingAccountNo);
    console.log(formValues.tradingAccountNo);
    setLoading(true);
    const response = await CorporateTraderService.getCorporateTraderList({
      // traderStageList: ['APPROVED'],
      tradingAccountNo: formValues.tradingAccountNo || '',
    });

    // const approvedApplications = response.traderList.filter(item => item.stage === 'APPROVED');

    setApplicationList(
      response.traderList.map(data => ({
        ...data,
        key: data.tradingAccountNo,
      })),
    );
    setTotalcount(response.totalCount);
    setLoading(false);
  };
  return (
    <>
      {open && (
        <Modal
          title={
            <Title level={4} style={{ marginTop: 0, marginBottom: '1.5rem', color: colorPrimary }}>
              Trading Account Detail
            </Title>
          }
          open={open}
          centered
          width={1000}
          onCancel={() => setOpen(false)}
          footer={[]}
        >
          <ShowDetail tradingAccountNo={tradingAccountNo} />
        </Modal>
      )}
      {!isModification && (
        <Title level={4} style={{ margin: '0 0 1.5rem 0' }}>
          Corporate Traders
        </Title>
      )}
      <Space.Compact style={{ float: 'right', marginBottom: '1rem' }}>
        {isModification ? (
          <Form onFinish={handleSearch}>
            <Space>
              <Form.Item name={'tradingAccountNo'}>
                <Input
                  size="middle"
                  allowClear
                  prefix={<SearchOutlined />}
                  // onChange={e => {
                  //   if (e.target.value === '') {
                  //     setAccountNo(null);
                  //   }
                  // }}
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" size={'middle'} htmlType="submit">
                  Search
                </Button>
              </Form.Item>
            </Space>
          </Form>
        ) : (
          <Input
            addonAfter={<SearchOutlined />}
            placeholder="Search"
            size={'middle'}
            allowClear
            onChange={e => setSearchText(e.target.value)}
          />
        )}
      </Space.Compact>

      <Table
        loading={loading}
        columns={tableColumns}
        dataSource={applicationList}
        size={'large'}
        scroll={{
          x: 'max-content',
        }}
        bordered
        pagination={{
          current: page,
          pageSize: size,
          total: totalCount,
        }}
        onChange={(pagination, filters, sorter) => {
          navigate(`/corporate?page=${pagination.current}&size=${pagination.pageSize}`);
        }}
      />
    </>
  );
}
